import { VERSION } from '@env/version';
import { RumInitConfiguration } from '@datadog/browser-rum';

interface customWindow extends Window {
  ONETRUST_KEY?: string;
  REST_CONFIG_API_URL?: string;
  REST_CONFIG_API_SUBSCRIPTION_KEY?: string;
  RECAPTCHA_KEY?: string;
  GOOGLE_ANALYTICS_KEY?: string;
}

const w = window as customWindow;

export const environment = {
  production: true,
  mock: false,
  cookieDomain: w.ONETRUST_KEY,
  REST_CONFIG: {
    API_URL: w.REST_CONFIG_API_URL + '/api/1.0/',
    API_URL_V2: w.REST_CONFIG_API_URL + '/api/2.0/',
    API_SUBSCRIPTION_KEY: w.REST_CONFIG_API_SUBSCRIPTION_KEY as string,
  },
  RECAPTCHA: {
    KEY: w.RECAPTCHA_KEY,
  },
  GOOGLE_ANALYTICS: {
    KEY: w.GOOGLE_ANALYTICS_KEY,
  },
  datadog: {
    config: {
      applicationId: 'ad02d115-0f8b-4ce7-aaed-2c47667c492d',
      clientToken: 'pubf81f6a21e044adbc55ca1dad007a2bd6',
      service: 'oss.fr.fr.digital.cat',
      env: 'prd',
    } satisfies Partial<RumInitConfiguration>,
  },
};
